import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

export interface IdentityCardDocument {
  _id: string;
  url: string;
  filename: string;
  size: number;
  documentType: { code: string; label: string };
}

@Injectable({
  providedIn: 'root',
})
export class IdentityCardService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  generateIdentityCard(passportNumber: string): Observable<IdentityCardDocument> {
    return this.http.get<IdentityCardDocument>(
      `${this.baseUrl}/identity-card/generate/${passportNumber}`,
      { headers: this.getAuthHeaders() }
    );
  }

  getIdentityCardDocument(passportNumber: string): Observable<IdentityCardDocument> {
    return this.http.get<IdentityCardDocument>(
      `${this.baseUrl}/identity-card/${passportNumber}/document`,
      { headers: this.getAuthHeaders() }
    );
  }
}
